import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;
  min-height: 38px;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.metrics.padding};
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
`;

export const Titulo = styled.h4`
  margin-left: ${({ theme }) => theme.metrics.margin};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textBackground};
`;
